import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Countdown, { getTimeDifference, zeroPad } from 'react-countdown-now';
import TimeSync from 'utils/TimeSync';

export const withDrawingCountdown = WrappedComponent => {
  return class extends Component {
    constructor(props) {
      super(props);
      this.state = {
        countDown: 0,
        step: 0,
        drumClosed:
          this.props.drawing.drawingState !== 'Upcoming' ||
          this.props.drawing.timeLeft() < 60000
      };

      this.renderDrumState = this.renderDrumState.bind(this);
    }

    updateStep = ({ total, days }) => {
      let step;
      const state = { countDown: total };
      if (days) {
        // step = 3600000 /*hr*/;
        step = 300000 /*5min*/;
      } else {
        step = 1000;
      }

      if (step !== this.state.step) {
        state.step = step;
      }
      if (total < 60000 && !this.state.drumClosed) {
        state.drumClosed = true;
      }
      this.setState(state);
      if (state.drumClosed) {
        this.props.onDrumClose && this.props.onDrumClose();
      }
    };

    componentDidMount() {
      const left = Date.now() + this.props.drawing.timeLeft();
      const delta = getTimeDifference(left);
      this.updateStep(delta);
    }

    renderCountDown = () => {
      const { drawing } = this.props;
      const renderer = ({ days /*number*/, hours, minutes, seconds }) => {
        let left;
        let className = this.state.drumClosed ? 'closed' : 'open';
        if (drawing.drawingState === 'InProgress') {
          left = 'NOW!';
        } else if (days) {
          left = days + (days > 1 ? ' Days' : ' Day');
        } else {
          className += ' notranslate';
          left =
            zeroPad(hours) + ':' + zeroPad(minutes) + ':' + zeroPad(seconds);
        }
        return <span className={className}>{left}</span>;
      };

      return (
        <Countdown
          key={this.state.step}
          date={TimeSync.toLocalTime(TimeSync.serverNow() + drawing.timeLeft())}
          renderer={renderer}
          intervalDelay={this.state.step}
          onTick={delta => this.updateStep(delta)}
        />
      );
    };

    renderDrumState(autoClaim) {
      if (!this.props.showDrumState) {
        return null;
      }

      if (this.state.countDown > 300000) {
        return (
          <div className="important">
            {!autoClaim && <h4>Important:</h4>}
            <span>
              {autoClaim
                ? 'Selected winners do not need to be present to receive prizes.'
                : 'Player must be on the windcreekcasino.com site at the time of the drawing to claim a prize.'}
            </span>
          </div>
        );
      }

      if (this.state.countDown > 120000) {
        return (
          <div className="drum-status">
            <span>Drum Status: </span>
            <span className="open">Open</span>
            <div className="minute-warning">
              Drum closes 1 minute before drawing occurs
            </div>
          </div>
        );
      }

      if (this.state.countDown >= 60000) {
        return (
          <div className="drum-status">
            <span>Drum Status: </span>
            <span className="closing">Closing</span>
            <div className="minute-warning">
              Drum closes 1 minute before drawing occurs
            </div>
          </div>
        );
      }

      return (
        <div className="drum-status">
          <span>Drum Status: </span>
          <span className="drum-status closed">Closed</span>
          <div>No more entries can be added</div>
        </div>
      );
    }

    render() {
      return (
        <WrappedComponent
          {...this.props}
          countDown={this.state.countDown}
          renderDrumState={this.renderDrumState}
          renderCountDown={this.renderCountDown}
        />
      );
    }
  };
};

//todo: update drawing shape
withDrawingCountdown.propTypes = {
  drawing: PropTypes.shape({
    drawingState: PropTypes.string.isRequired,
    timeLeft: PropTypes.func.isRequired
  }).isRequired,
  onDrumClose: PropTypes.func,
  showDrumState: PropTypes.bool
};
